import React from "react";
import { AuthProvider, useAuth } from "../context/AuthContext";
import AppAuth from "../components/AppAuth";
import AppShell from "../components/AppShell";
import { Loader2 } from "lucide-react";

function Gate() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#07090a] flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-[#2fd645]" />
      </div>
    );
  }
  return user ? <AppShell /> : <AppAuth />;
}

export default function AppPage() {
  return (
    <AuthProvider>
      <Gate />
    </AuthProvider>
  );
}
